import React, { useState } from 'react';
import Navbar from './components/layout/Navbar';
import MobileDrawer from './components/layout/MobileDrawer';
import Footer from './components/layout/Footer';
import WhatsAppFloat from './components/common/WhatsAppFloat';

import HeroSection from './components/sections/HeroSection';
import AboutSection from './components/sections/AboutSection';
import ProductSection from './components/sections/ProductSection';
import FactorySection from './components/sections/FactorySection';
import DifferentialsSection from './components/sections/DifferentialsSection';
import FinalCtaSection from './components/sections/FinalCtaSection';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <MobileDrawer menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <WhatsAppFloat />

      <main>
        <HeroSection />
        <div className="gold-bar" />
        <AboutSection />
        <ProductSection />
        <FactorySection />
        <DifferentialsSection />
        <FinalCtaSection />
      </main>

      <Footer />
    </>
  );
}

export default App;